import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

let baseUrl = API_BASE_URL
//let baseUrl = process.env.VUE_APP_API_BASE_URL

export const repairOptionApiService = {
    getInstructionFilterPagenated,
    getMatrixFilterPagenated,
    getDeviceTypes,
    getDeviceMakes,
    getincidentTypes,
    getProviders,
    previewOptionsForGadget,
    getWebDisplayItems,
    getEmailTemplates,
    addManualOptionForGadget,
    getManDeviceRepairPreConfigItems,
    addManualOptionForGadgetFromPreConfig,
    delManualOption,
    addManualOptionForGadgetFromSys,
    cancelSelectedOption,
    addSelectedOptionNote,
    setSelectedOption,
    setSelectedOptionBER,
    setSelectedOptionQuoteOnly,
    setSelectedOptionFaulty,
    queryMatrix,
    setSelectedOptionFaulty,
    getSelectedSettlementOptionTasks,
    getSettlementOptionHistory,
    getSettlementOptionOutstandingTasks,
    setSettlementOptionTasksComplete,
    getSupplierImportRROptionStatusTypes
}

function queryMatrix(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/querymatrix', payload)
}

function getMatrixFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/matrix', payload)
}

function getInstructionFilterPagenated(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/instructions', payload)
}

function getDeviceTypes() {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/devicetypes')
}

function getDeviceMakes() {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/devicemakes')
}

function getincidentTypes() {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/incidentTypes')
}

function getProviders() {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/providers')
}

function getEmailTemplates() {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/emailtemplates')
}

function getWebDisplayItems() {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/webdisplayitems')
}

//function getManDeviceRepairPreConfigItems() {
//    return axios.get(baseUrl + '/api/admin/v1/repairoption/manpreconfig')
//}

function getManDeviceRepairPreConfigItems(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/manpreconfig', payload)
}

function previewOptionsForGadget(payload) {
    return axios.get(baseUrl + '/api/admin/v1/repairreplace/optionsforgadget/' + payload)
}

function addManualOptionForGadget(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/addmanualoptionforgadget', payload)
}

function addManualOptionForGadgetFromPreConfig(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/addmanualoptionforgadgetpre', payload)
}

function delManualOption(payload) {
    return axios.get(baseUrl + '/api/admin/v1/repairoption/delmanualoption/' + payload)
}

function addManualOptionForGadgetFromSys(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/addmanualoptionforgadgetsys', payload)
}

function cancelSelectedOption(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/cancelSelectedRROption', payload)
}

function addSelectedOptionNote(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/addSelectedRROptionNote', payload)
}

function setSelectedOption(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/setSelectedRROption', payload)
}

function setSelectedOptionBER(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/setSelectedRROptionBER', payload)
}

function setSelectedOptionQuoteOnly(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/setSelectedRROptionQuoteOnly', payload)
}

function setSelectedOptionFaulty(payload) {
    return axios.post(baseUrl + '/api/admin/v1/repairoption/setSelectedRROptionFaulty', payload)
}

function getSelectedSettlementOptionTasks(payload) {
    return axios.post(baseUrl + '/api/admin/v1/settlementoption/search', payload)
}

function getSettlementOptionHistory(payload) {
    return axios.get(baseUrl + '/api/admin/v1/settlementoption/history/' + payload)
}

function getSettlementOptionOutstandingTasks(payload) {
    return axios.get(baseUrl + '/api/admin/v1/settlementoption/tasks/' + payload)
}

function setSettlementOptionTasksComplete(payload) {
    return axios.post(baseUrl + '/api/admin/v1/settlementoption/tasks/complete', payload)
}

function getSupplierImportRROptionStatusTypes() {
    return axios.get(baseUrl + '/api/admin/v1/settlementoption/getstatustypes/')
}
